import { Component } from "../Component.js";
import { i18n } from "../../globalization/i18n.js";
import { Services } from "../../services/Services.js";
import { generateUid } from "../../utils/uid.js";

export class StatusOverlay extends Component {

    constructor(parent, options = {}) {

        if (!options.id)
            options.id = generateUid();

        super(parent, options);

        this.visible = 0;

    };

    getTitle() {

        return i18n.t('component.status_overlay.title');

    };

    isVisible() {

        return this.visible > 0;

    };

    show() {

        this.visible++;
        this.invalidate();

    };

    hide() {

        this.visible--;
        if (this.visible < 0) {
            console.warn('Status overlay error: visible counter is negative!');
            this.visible = 0;
        }
        this.invalidate();

    };

    _render(vm) {

        const ct = Services.get('templates');

        const overlay = this;
        const visible = overlay.visible;
        const id = this.getId();

        if (!visible)
            return ct.div({ id });

        return ct.div({ id }, [
            ct.el('.overlay.blur' + (visible ? '.active' : '')),
            ct.el('dialog' + (visible ? '.active' : ''), [
                ct.h1([
                    ct.icon('spinner', '.fa-spin-pulse.fa-1x'),
                    ' ',
                    overlay.getTitle()
                ]),
            ]),
        ]);

    };

}